// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface FeaturedLane {
  id: string;
  name: string;
  description: string | null;
  emoji: string;
  reaction_type: string;
  sort_order: number;
}

interface FeaturedAthlete {
  id: string;
  lane_id: string;
  profile_id: string;
  featured_post_id: string | null;
  week_start: string;
  score: number;
  profile: {
    id: string;
    name: string | null;
    avatar_url: string | null;
    username: string | null;
  } | null;
}

interface LaneWithAthletes extends FeaturedLane {
  athletes: FeaturedAthlete[];
}

export const useFeaturedLanes = () => {
  const [lanes, setLanes] = useState<LaneWithAthletes[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLanes = async () => {
      setIsLoading(true);
      
      // Calculate current week start (Monday)
      const now = new Date();
      const dayOfWeek = now.getDay();
      const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      const weekStart = new Date(now.setDate(diff));
      weekStart.setHours(0, 0, 0, 0);
      const weekStartStr = weekStart.toISOString().split('T')[0];

      // Fetch lanes
      const { data: lanesData, error: lanesError } = await supabase
        .from('wall_featured_lanes')
        .select('*')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });

      if (lanesError) {
        console.error('Error fetching lanes:', lanesError);
        setIsLoading(false);
        return;
      }

      // Fetch featured athletes for current week
      const { data: athletesData, error: athletesError } = await supabase
        .from('wall_featured_athletes')
        .select(`
          *,
          profile:profiles(id, name, avatar_url, username)
        `)
        .eq('week_start', weekStartStr)
        .order('score', { ascending: false });

      if (athletesError) {
        console.error('Error fetching athletes:', athletesError);
      }

      // Combine lanes with athletes
      const lanesWithAthletes: LaneWithAthletes[] = (lanesData || []).map(lane => ({
        ...lane,
        athletes: (athletesData || [])
          .filter(a => a.lane_id === lane.id)
          .slice(0, 3)
      }));

      setLanes(lanesWithAthletes);
      setIsLoading(false);
    };

    fetchLanes();
  }, []);

  return { lanes, isLoading };
};
